<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar
        :slot="isLargeDisplay ? 'top' : 'bottom'"
        v-if="
          !(
            useStore().activeBooking.bookingType &&
            router.currentRoute.value.name === 'newBooking'
          )
        "
        style="border-bottom: 0"
      >
        <ion-tab-button tab="home" href="/home">
          <ion-icon :icon="listOutline" />
          <ion-label>{{ $t('base.reporting.title') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="newBooking" href="/newBooking">
          <ion-icon :icon="carSportOutline" />
          <ion-label>{{ $t('base.newBooking.button') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="profile" href="/profile">
          <ion-icon :icon="personOutline" />
          <ion-label>{{ $t('base.profile') }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonIcon,
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonLabel,
} from '@ionic/vue';
import { listOutline, carSportOutline, personOutline } from 'ionicons/icons';
import { useStore } from '@/store';
import router from '@/router';
import { useResponsive } from '@/composables/useResponsive';

const { isLargeDisplay } = useResponsive();
</script>
